import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import OtherLabsIframe from "../Screens_old/OtherLab/student/iframe";
import PageNotFound from "../Screens1/Common/PageNotFound";

const IframeNavigation = () => {

    return (
        (
            <>
                <Routes>
                    <Route path="other/:activityID" element={<OtherLabsIframe />} />
                    <Route
                        path="*"
                        element={<PageNotFound />}
                    />
                </Routes>
            </>
        )
    );
};

export default IframeNavigation;